import './assets/css/bootstrap-custom.css';
import './assets/css/style.css';
import Routes from './Routes';

function App() {
  return <Routes />;
}

export default App;
